<template>
  <div class="col-md-12 mx-auto">
    <div :style="{background: color.sectionColor.backGround,color: color.sectionColor.text}"
         class="container position-relative">
      <div v-if="data.product.discount"
           class="bg-danger p-6 text-white font-weight-bold rounded-circle position-absolute zindex-1"
           style="top: -10px;left: -10px">{{ data.product.discount }}%
      </div>
      <div class="wrapper">
        <div v-if="!data.product.icon" :style="{'background':backSet}" class="banner-image"></div>
        <div v-if="data.product.icon" class="banner-image">
          <v-icon>{{ data.product.icon }}</v-icon>
        </div>

        <h1 :style="{color: color.sectionColor.text}" class="my-2"> {{ data.product.title }}</h1>
        <div v-if="hasProperty" :style="{color: color.sectionColor.text}">
          <p class="text-right font-weight-bold">ویژگی ها</p>
          <div class="row mx-auto py-0 my-0" v-for="(item, index) in data.product.details" :key="index">
            <div class="col-md-6 mt-0 py-0">
              <p>{{ item.label }} : </p>
            </div>
            <div class="col-md-6 my-0 py-0">
              <p>{{ item.value }}</p>
            </div>
          </div>
        </div>
        <p v-if="data.product.content" v-html="data.product.content"></p>
        <h4 v-if="data.product.price" :style="{'text-decoration':data.product.discount ? 'line-through' : ''}">
          {{ data.product.price | currency |persianNum }} ﷼</h4>
        <span v-if="data.product.discount">
          {{ data.product.price - ((data.product.price * data.product.discount) / 100) | currency|persianNum }} ﷼
        </span>
      </div>
      <div class="button-wrapper">
        <button @click="gotPaylink(data.product.payLink)" type="button" class="btn fill">خرید می کنم!</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cardMaker',

  props: {
    data: {},
    color: {},
  },
  methods: {
    gotPaylink(link) {
      window.open(link, '_blank');
    }
  },
  computed: {
    backSet() {
      if (this.data.product.image.images.length>0) {
        return `url(${this.data.product.image.images[0].url})`
      } else if (this.data.product.color) {
        return this.data.product.color
      } else return `url(https://i.postimg.cc/NfR2yhNs/image-equilibrium.jpg)`
    },
    hasProperty() {
      return this.data.product.details
          && this.data.product.details.length > 0
          && this.data.product.details.filter(item => !!item.label || !!item.value).length > 0
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Righteous&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300&display=swap');

.container {
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  background-color: rgba(17, 25, 40, 0.25);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.125);
  padding: 30px;
  filter: drop-shadow(0 30px 10px rgba(0, 0, 0, 0.125));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

}

.wrapper {
  width: 100%;
  height: 100%;

}

.banner-image {
  background-position: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  height: 230px !important;
  width: 100% !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.255) !important
}

h1 {
  font-family: 'Righteous', sans-serif;
  color: rgba(255, 255, 255, 0.98);
  text-transform: uppercase;
  font-size: 2rem;
}

p {
  color: #fff;
  font-family: 'Lato', sans-serif;
  text-align: center;
  font-size: 0.8rem;
  line-height: 150%;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.button-wrapper {
  margin-top: 18px;
}

.btn {
  border: none;
  padding: 12px 24px;
  border-radius: 24px;
  font-size: 12px;
  font-size: 0.8rem;
  letter-spacing: 2px;
  cursor: pointer;
}

.btn + .btn {
  margin-left: 10px;
}

.outline {
  background: transparent;
  color: rgba(35, 23, 175, 0.9);
  border: 1px solid rgba(35, 23, 175, 0.9);
  transition: all .3s ease;

}

.outline:hover {
  transform: scale(1.125);
  color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.9);
  transition: all .3s ease;
}

.fill {
  background: rgba(35, 23, 175, 0.9);
  color: rgba(255, 255, 255, 0.95);
  filter: drop-shadow(0);
  font-weight: bold;
  transition: all .3s ease;
}

.fill:hover {
  transform: scale(1.125);
  border-color: rgba(255, 255, 255, 0.9);
  filter: drop-shadow(0 10px 5px rgba(0, 0, 0, 0.125));
  transition: all .3s ease;
}

.cr {
  width: 200px;
  padding: 16px;
  position: absolute;
  text-align: center;
  color: #f0f0f0;
}

.cr-sticky {
  position: fixed;
}

/* Positions */

.cr-top {
  top: 25px;
}

.cr-bottom {
  bottom: 25px;
}

.cr-left {
  left: -50px;
}

.cr-right {
  right: -50px;
}

/* Rotations */

.cr-top.cr-left,
.cr-bottom.cr-right {
  transform: rotate(-45deg);
}

.cr-top.cr-right,
.cr-bottom.cr-left {
  transform: rotate(45deg);
}

/* Colors */

.cr-white {
  background-color: #f0f0f0;
  color: #444;
}

.cr-black {
  background-color: #333;
}

.cr-grey {
  background-color: #999;
}

.cr-blue {
  background-color: #39d;
}

.cr-green {
  background-color: #2c7;
}

.cr-turquoise {
  background-color: #1b9;
}

.cr-purple {
  background-color: #95b;
}

.cr-red {
  background-color: #e43;
}

.cr-orange {
  background-color: #e82;
}

.cr-yellow {
  background-color: #ec0;
}
</style>